import LangEnum from '../../../lang/LangEnum';
import { GridSizeEnum } from '../enums/gridSize.enum';

export const getGridSizeLangEnum = (value: GridSizeEnum) => {
  const mappedLabel: {
    [key in GridSizeEnum]: { label: LangEnum; description: LangEnum };
  } = {
    NORMAL: {
      label: LangEnum.GLOBAL_GRID_SIZE_NORMAL,
      description: LangEnum.GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_NORMAL_OPTION_DESCRIPTION,
    },
    LARGE: {
      label: LangEnum.GLOBAL_GRID_SIZE_LARGE,
      description: LangEnum.GENERAL_SETTINGS_GRID_SIZE_SETTINGS_SELECT_LARGE_OPTION_DESCRIPTION,
    },
  };
  return mappedLabel[value];
};
